import React, { Component } from 'react';
import { connect } from 'react-redux';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import TextInput from 'screens/components/basic/TextInput';
import CheckInput from 'screens/components/basic/CheckInput';
import ToggleInput from 'screens/components/basic/ToggleInput';
import UISelectInput from './UISelectInput';
import Button from 'screens/components/basic/Button';
import {
  getDeliveryZone,
  getWebUISettings,
  updateWebUISettings,
  getStoreToDoorLocationInformation,
  getStoreLockDateNTime,
} from 'actions/EntityActions';
import { selectWebUISettings } from 'selectors/entitySelector';
import LOOKUP from 'constants/lookup';
import { uiSettingsCrumb } from 'utils/breadcrumbInfo';
import CardSimple from 'screens/components/basic/CardSimple';
import Grid from 'screens/components/basic/Grid';
import DeliveryZone from './DeliveryZoneComponent/DeliveryZone';
import { formInput } from 'actions/FormActions';
import StoreLockDateAndTime from './StoreLockDateAndTimeComponent/StoreLockDateAndTime';
import WithRouter from 'custom/withRouter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import StoretoDoorDeliveryWindow from './StoreLockDateAndTimeComponent/StoretoDoorDeliveryWindow';
import SelectInput from 'screens/components/basic/SelectInput';

const compName = 'WebUISetting';

class UISettingPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startTime: null,
      endTime: null,
      isDeliverySectionOpen: false,
      isStoreLockDateAndTimeOpen: false,
      isAdvancedDeliveryVisible: false,
      isWindowVisible: false,
    };
  }

  componentDidMount() {
    this.props.getWebUISettings(this.props.branchId, compName);
    this.props.getDeliveryZone(this.props.branchId);
    this.props.getStoreLockDateNTime(this.props.branchId);
  }

  toggleWindowVisibility = () => {
    this.setState((prevState) => ({
      isWindowVisible: !prevState.isWindowVisible, // Toggle the visibility state
    }));
  };

  componentDidUpdate(prevProps) {
    if (this.props.deliveryStartTime !== prevProps.deliveryStartTime) {
      this.setState((pState) => ({
        ...pState,
        startTime: this.props.deliveryStartTime,
      }));
    }
    if (this.props.deliveryEndTime !== prevProps.deliveryEndTime) {
      this.setState((pState) => ({
        ...pState,
        endTime: this.props.deliveryEndTime,
      }));
    }

    if (
      this.props.deliveryZone &&
      this.props.deliveryZone !== prevProps.deliveryZone
    ) {
      this.props.formInput(false, 'WebUISettingDeliveryZone');
    }

    if (
      this.props.createStoreLockDateNTimeSuccess !==
        prevProps.createStoreLockDateNTimeSuccess ||
      this.props.deleteStoreLockDateNTimeSuccess !==
        prevProps.deleteStoreLockDateNTimeSuccess ||
      this.props.updateStoreLockDateNTimeSuccess !==
        prevProps.updateStoreLockDateNTimeSuccess
    ) {
      this.props.getStoreLockDateNTime(this.props.branchId);
    }
  }

  handleDeliveryToggle = () => {
    this.setState((prevState) => ({
      isDeliverySectionOpen: !prevState.isDeliverySectionOpen,
    }));
  };

  handleStoreLockDateAndTimeToggle = () => {
    this.setState((prevState) => ({
      isStoreLockDateAndTimeOpen: !prevState.isStoreLockDateAndTimeOpen,
    }));
  };

  getStoreToDoorLocationInformation = () => {
    this.props.getStoreToDoorLocationInformation(this.props.branchId);
  };

  saveWebUISettings = (isError) => {
    if (!isError) {
      return this.props.updateWebUISettings({
        webUIModel: this.props.webUISettingModel,
      });
    }

    const selectField = document.querySelector(
      '[data-testid="my-select-field"]'
    );
    if (selectField) {
      selectField.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  redirectToDashboard = () => {
    this.props.navigate('/');
  };

  toggleWindowDeliveryAdvanceVisibility = () => {
    this.setState((prevState) => ({
      isAdvancedDeliveryVisible: !prevState.isAdvancedDeliveryVisible, // Toggle the visibility state
    }));
  };

  generateTimeData(startHour, endHour) {
    const timeData = [];
    for (let i = startHour; i <= endHour; i++) {
      if (i === 24) {
        timeData.push({ text: '12:00 am', value: i });
        continue;
      }
      timeData.push({
        text: (i % 12 || 12) + ':00 ' + (i >= 12 ? 'pm' : 'am'),
        label: (i % 12 || 12) + ':00 ' + (i >= 12 ? 'pm' : 'am'),
        value: i,
      });
    }
    timeData.unshift({ text: 'Not set', value: null });
    return timeData;
  }

  getBannerDisplayModeOptions = () => {
    return [
      { value: 4, text: 'None' },
      { value: 1, text: 'Surf' },
      { value: 2, text: 'Custom' },
      { value: 3, text: 'Both' },
    ];
  };
  render() {
    const timeData = this.generateTimeData(8, 24); // generates options for delivery time select input (currently set to 10:00am to 12:00am midnight)
    const { isAdvancedDeliveryVisible } = this.state;
    const isTimeSet = !!(this.state.startTime && this.state.endTime);
    const { isWindowVisible } = this.state;
    const isTimeNotSet = !this.state.startTime && !this.state.endTime;
    const isTimeError = isTimeSet && this.state.endTime <= this.state.startTime;
    const isTimeSetError =
      isTimeSet || isTimeNotSet
        ? false
        : !this.state.startTime
          ? 'start'
          : 'end';
    return (
      <Grid headerContent={uiSettingsCrumb}>
        <CardSimple title="Header Settings" className="mt-2">
          <div className="row">
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <TextInput
                name={compName + 'headerBackgroundColor'}
                floatingLabelText={'headerBackgroundColor'}
                hintText={'headerBackgroundColor'}
                label={'headerBackgroundColor'}
                fullWidth={true}
                maxLength={50}
              />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <TextInput
                name={compName + 'headerBackgroundImageUrl'}
                label={'headerBackgroundImageUrl'}
                floatingLabelText={'headerBackgroundImageUrl'}
                hintText={'headerBackgroundImageUrl'}
                fullWidth={true}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <TextInput
                name={compName + 'headerForegroundColor'}
                label={'headerForegroundColor'}
                floatingLabelText={'headerForegroundColor'}
                hintText={'headerForegroundColor'}
                fullWidth={true}
                maxLength={50}
              />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <TextInput
                name={compName + 'headerLogoUrl'}
                label={'headerLogoUrl'}
                floatingLabelText={'headerLogoUrl'}
                hintText={'headerLogoUrl'}
                fullWidth={true}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <TextInput
                name={compName + 'headerForegroundColor'}
                label={'headerForegroundColor'}
                floatingLabelText={'headerForegroundColor'}
                hintText={'headerForegroundColor'}
                fullWidth={true}
                maxLength={50}
              />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <TextInput
                name={compName + 'headerLogoUrl'}
                label={'headerLogoUrl'}
                floatingLabelText={'headerLogoUrl'}
                hintText={'headerLogoUrl'}
                fullWidth={true}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <TextInput
                name={compName + 'headerBusinessName'}
                label={'headerBusinessName'}
                floatingLabelText={'headerBusinessName'}
                hintText={'headerBusinessName'}
                fullWidth={true}
                maxLength={50}
              />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <br />
              <br />
              <ToggleInput
                className="cart_status btnToggleLabel"
                name={compName + 'sideCartModeEnabled'}
                label={'Opening the basket from side'}
              />
            </div>
          </div>
        </CardSimple>
        <CardSimple title="Body Settings" className="mt-2">
          <div className="row">
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <TextInput
                name={compName + 'bodyBackgroundColor'}
                label={'bodyBackgroundColor'}
                floatingLabelText={'bodyBackgroundColor'}
                hintText={'bodyBackgroundColor'}
                fullWidth={true}
                maxLength={50}
              />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <TextInput
                name={compName + 'bodyBackgroundImageUrl'}
                label={'bodyBackgroundImageUrl'}
                floatingLabelText={'bodyBackgroundImageUrl'}
                hintText={'bodyBackgroundImageUrl'}
                fullWidth={true}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <TextInput
                name={compName + 'bodyButtonBackgroudColor'}
                label={'bodyButtonBackgroudColor'}
                floatingLabelText={'bodyButtonBackgroudColor'}
                hintText={'bodyButtonBackgroudColor'}
                fullWidth={true}
                maxLength={50}
              />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <TextInput
                name={compName + 'bodyButtonForegroundColor'}
                label={'bodyButtonForegroundColor'}
                floatingLabelText={'bodyButtonForegroundColor'}
                hintText={'bodyButtonForegroundColor'}
                fullWidth={true}
                maxLength={50}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <TextInput
                name={compName + 'snackbarBackgroundColor'}
                label={'Warning Message Background Color'}
                floatingLabelText={'Warning Message Background Color'}
                hintText={'Warning Message Background Color'}
                fullWidth={true}
                maxLength={50}
              />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <br />
              <br />
              <ToggleInput
                className="patient_status btnToggleLabel"
                name={compName + 'endlessScroll'}
                label={'Search Results Endless Scroll'}
              />
            </div>
              <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <br />
              <br />
              <ToggleInput
                className="cart_status btnToggleLabel"
                name={compName + 'showMemberPriceBeforeLogin'}
                label={'Show Member Price Before Login'}
              />
            </div>
          </div>
        </CardSimple>
        <CardSimple title="Banner Settings" className="mt-2">
          <div className="row">
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <SelectInput
                name={`${compName}bannerDisplayMode`}
                floatingLabelText="Banner Display Mode"
                options={this.getBannerDisplayModeOptions()}
                fullWidth={true}
                defaultValue={4}
              />
            </div>
          </div>
        </CardSimple>
        <CardSimple title="Footer Settings" className="mt-2">
          <div className="row">
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <TextInput
                name={compName + 'footerBackgroundColor'}
                label={'footerBackgroundColor'}
                floatingLabelText={'footerBackgroundColor'}
                hintText={'footerBackgroundColor'}
                fullWidth={true}
                maxLength={50}
              />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <TextInput
                name={compName + 'footerBackgroundImageUrl'}
                label={'footerBackgroundImageUrl'}
                floatingLabelText={'footerBackgroundImageUrl'}
                hintText={'footerBackgroundImageUrl'}
                fullWidth={true}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <TextInput
                name={compName + 'footerForegroundColor'}
                label={'footerForegroundColor'}
                floatingLabelText={'footerForegroundColor'}
                hintText={'footerForegroundColor'}
                fullWidth={true}
                maxLength={50}
              />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <TextInput
                name={compName + 'footerLogoUrl'}
                label={'footerLogoUrl'}
                floatingLabelText={'footerLogoUrl'}
                hintText={'footerLogoUrl'}
                fullWidth={true}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <TextInput
                name={compName + 'footerBusinessName'}
                label={'footerBusinessName'}
                floatingLabelText={'footerBusinessName'}
                hintText={'footerBusinessName'}
                fullWidth={true}
                maxLength={50}
              />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <TextInput
                name={compName + 'footerAddress'}
                label={'footerAddress'}
                floatingLabelText={'footerAddress'}
                hintText={'footerAddress'}
                fullWidth={true}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <TextInput
                name={compName + 'footerPhone'}
                label={'footerPhone'}
                floatingLabelText={'footerPhone'}
                hintText={'footerPhone'}
                fullWidth={true}
                maxLength={50}
              />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <TextInput
                name={compName + 'footerVistTimeOne'}
                label={'footerVistTimeOne'}
                floatingLabelText={'footerVistTimeOne'}
                hintText={'footerVistTimeOne'}
                fullWidth={true}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <TextInput
                name={compName + 'footerVistTimeTwo'}
                label={'footerVistTimeTwo'}
                floatingLabelText={'footerVistTimeTwo'}
                hintText={'footerVistTimeTwo'}
                fullWidth={true}
              />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <TextInput
                name={compName + 'footerVistTimeThree'}
                label={'footerVistTimeThree'}
                floatingLabelText={'footerVistTimeThree'}
                hintText={'footerVistTimeThree'}
                fullWidth={true}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <TextInput
                name={compName + 'footerTwoBackgroundColor'}
                label={'footerTwoBackgroundColor'}
                floatingLabelText={'footerTwoBackgroundColor'}
                hintText={'footerTwoBackgroundColor'}
                fullWidth={true}
                maxLength={50}
              />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <TextInput
                name={compName + 'footerTwoBackgroudImageUrl'}
                label={'footerTwoBackgroudImageUrl'}
                floatingLabelText={'footerTwoBackgroudImageUrl'}
                hintText={'footerTwoBackgroudImageUrl'}
                fullWidth={true}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <TextInput
                name={compName + 'footerTwoForegroundColor'}
                label={'footerTwoForegroundColor'}
                floatingLabelText={'footerTwoForegroundColor'}
                hintText={'footerTwoForegroundColor'}
                fullWidth={true}
                maxLength={50}
              />
            </div>
          </div>
        </CardSimple>
        <Accordion
          className="AccordionSimple mt-2"
          defaultExpanded={this.state.isStoreLockDateAndTimeOpen}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="store-lock-date-time-content"
            id="store-lock-date-time-header"
          >
            <h4>Store Lock Date And Time</h4>
          </AccordionSummary>
          <AccordionDetails>
            <div className="row">
              <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 deliverytooltip">
                <CheckInput
                  name={compName + 'storeLockDateAndTimeEnabled'}
                  text={'Enable Store Lock Date And Time'}
                  floatingLabelText={'storeLockDateAndTimeEnabled'}
                  hintText={'storeLockDateAndTimeEnabled'}
                />
              </div>
              <br />
            </div>
            <StoreLockDateAndTime />
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="AccordionSimple mt-2"
          defaultExpanded={this.state.isDeliverySectionOpen}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="delivery-content"
            id="delivery-header"
          >
            <h4>Delivery</h4>
          </AccordionSummary>
          <AccordionDetails>
            <h3
              style={{
                textAlign: 'center',
                margin: '0 0 30px 0',
                fontSize: '18px',
                fontWeight: '600',
              }}
            >
              Choose your Delivery Settings by Radius (Kms) or Zones (City).
              Both options cannot be selected at once
            </h3>
            <div className="row">
              <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 deliverytooltip">
                <CheckInput
                  name={compName + 'deliverToHomeEnabled'}
                  text={'Enable Delivery to Home'}
                  floatingLabelText={'deliverToHomeEnabled'}
                  hintText={'deliverToHomeEnabled'}
                />
              </div>
              <br />
            </div>
            <div className="row">
              <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 deliverytootip mb-3">
                <span style={{ color: `grey` }}>
                  Max Delivery by Radius (km)
                  <FontAwesomeIcon
                    icon={faQuestionCircle}
                    className="link_default green-text font-18px mx-2"
                    title="Use this setting to limit delivery distance, by setting a maximum delivery radius from your store"
                  />
                </span>
                <br />
                <TextInput
                  name={compName + 'deliveryRadius'}
                  type={'number'}
                  fullWidth={true}
                  maxLength={50}
                  className="tooltiptextfield"
                />
              </div>
              <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 deliverytootip mb-3">
                <span style={{ color: `grey` }}>
                  Base Delivery Cost ($)
                  <FontAwesomeIcon
                    icon={faQuestionCircle}
                    className="link_default green-text font-18px mx-2"
                    title="This is for the base charge setting for delivery cost (can be $0) extra distance fees get added to the base charge"
                  />
                </span>
                <br />
                <TextInput
                  name={compName + 'shippingCost'}
                  type={'number'}
                  fullWidth={true}
                  maxLength={50}
                  className="tooltiptextfield"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 deliverytootip mb-3">
                <span style={{ color: `grey` }}>
                  Delivery Minimum Amount Threshold ($)
                  <FontAwesomeIcon
                    icon={faQuestionCircle}
                    className="link_default green-text font-18px mx-2"
                    title="Set a limit for the minimum order subtotal that qualifies for delivery to home"
                  />
                </span>
                <br />
                <TextInput
                  name={compName + 'deliveryMininumAmountThreshold'}
                  type={'number'}
                  fullWidth={true}
                  maxLength={50}
                  className="tooltiptextfield"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <a
                  href="#"
                  style={{
                    textDecoration: 'underline',
                    color: 'blue !important',
                  }}
                  onClick={(e) => {
                    e.preventDefault(); // Prevent default link behavior
                    this.toggleWindowDeliveryAdvanceVisibility();
                  }}
                >
                  Display Advanced Delivery Settings
                </a>
                <br />
              </div>
              <br />
            </div>
            {isAdvancedDeliveryVisible && (
              <div>
                <div className="row">
                  <span className="ml-2">
                    <i>
                      Set distance/amount for a delivery with a fee of the Base
                      Charge. Base Charge can be $0
                    </i>
                  </span>
                  <br />
                  <br />
                  <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 deliverytootip mb-3">
                    <span style={{ color: `grey` }}>
                      Order Amount($) Minimum for Base Charge Delivery
                      <FontAwesomeIcon
                        icon={faQuestionCircle}
                        className="link_default green-text font-18px mx-2"
                        title="Order Subtotal Minimum Amount to qualify for base charge only, distance condition must also be met to qualify"
                      />
                    </span>
                    <br />
                    <TextInput
                      name={compName + 'freeDeliveryThreshold'}
                      type={'number'}
                      fullWidth={true}
                      maxLength={50}
                      className="tooltiptextfield"
                    />
                  </div>
                  <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 deliverytootip mb-3">
                    <span style={{ color: `grey` }}>
                      Distance(km) Maximum for Base Charge Delivery
                      <FontAwesomeIcon
                        icon={faQuestionCircle}
                        className="link_default green-text font-18px mx-2"
                        title="Order Delivery Radius Maximum to qualify for base charge only, cost condition must also be met to qualify"
                      />
                    </span>
                    <br />
                    <TextInput
                      name={compName + 'freeDeliveryDistanceCutoff'}
                      type={'number'}
                      fullWidth={true}
                      maxLength={50}
                      className="tooltiptextfield"
                    />
                  </div>
                </div>
                <div className="row">
                  <span className="ml-2">
                    <i>
                      set up the cost for delivery that is dependent on delivery
                      radius.
                    </i>
                  </span>
                  <br />
                  <br />
                  <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 deliverytootip mb-3">
                    <span style={{ color: `grey` }}>
                      Delivery Cost Step ($)
                      <FontAwesomeIcon
                        icon={faQuestionCircle}
                        className="link_default green-text font-18px mx-2"
                        title="When calculating delivery cost, specify an amount per distance"
                      />
                    </span>
                    <br />
                    <TextInput
                      name={compName + 'deliveryCostStep'}
                      type={'number'}
                      fullWidth={true}
                      maxLength={50}
                      className="tooltiptextfield"
                    />
                  </div>
                  <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 deliverytootip mb-3">
                    <span style={{ color: `grey` }}>
                      Delivery Distance Step (km)
                      <FontAwesomeIcon
                        icon={faQuestionCircle}
                        className="link_default green-text font-18px mx-2"
                        title="When calculating delivery cost, specify a distance value related to the cost step"
                      />
                    </span>
                    <br />
                    <TextInput
                      name={compName + 'deliveryDistanceStep'}
                      type={'number'}
                      fullWidth={true}
                      maxLength={50}
                      className="tooltiptextfield"
                    />
                  </div>
                </div>
              </div>
            )}
            <br />
            <br />
            <div className="row mb-3">
              <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 deliverytootip">
                <span style={{ color: `grey` }}>
                  Delivery Supplementary Text
                  <FontAwesomeIcon
                    icon={faQuestionCircle}
                    className="link_default green-text font-18px mx-2"
                    title="Specify a message for the customer when they are entering their delivery details"
                  />
                </span>
                <br />
                <TextInput
                  name={compName + 'deliverySupplementaryText'}
                  type={'string'}
                  fullWidth={true}
                  maxLength={200}
                  className="tooltiptextfield"
                />
              </div>
              <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 deliverytootip">
                <span style={{ color: `grey` }}>
                  Delivery Order Email Text
                  <FontAwesomeIcon
                    icon={faQuestionCircle}
                    className="link_default green-text font-18px mx-2"
                    title="Specify a message about delivery for the customer when they receive an email about their order"
                  />
                </span>
                <br />
                <TextInput
                  name={compName + 'deliveryOrderEmailText'}
                  type={'string'}
                  fullWidth={true}
                  maxLength={200}
                  className="tooltiptextfield"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6  mb-3">
                <span style={{ color: `grey` }}>
                  Delivery Start Time
                  <FontAwesomeIcon
                    icon={faQuestionCircle}
                    className="link_default green-text font-18px mx-2"
                    title="When set, this is the daily start time that customers can schedule deliveries"
                  />
                </span>
                <br />
                <UISelectInput
                  name={compName + 'deliveryStartHour'}
                  fullWidth={true}
                  options={timeData}
                  compName={compName}
                  errorText={
                    isTimeSetError === 'start' &&
                    "Please set a Start Time, or change End Time to 'Not Set'"
                  }
                  errorStyle={{
                    color: '#ed4559',
                    fontFamily: 'Open Sans',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    fontStyle: 'italic',
                    marginTop: '7px',
                  }}
                />
              </div>
              <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6  mb-3">
                <span style={{ color: `grey` }}>
                  Delivery End Time{' '}
                  <icon
                    className="link_default green-text glyphicon glyphicon-question-sign font-18px "
                    title="When set, this is the daily end time that customers can schedule deliveries"
                  />
                </span>
                <br />
                <UISelectInput
                  data-testid="my-select-field"
                  name={compName + 'deliveryEndHour'}
                  fullWidth={true}
                  options={timeData}
                  compName={compName}
                  errorText={
                    (isTimeError &&
                      "'Delivery End Time' must be greater than 'Delivery Start Time'") ||
                    (isTimeSetError === 'end' &&
                      "Please set an End Time, or change Start Time to 'Not Set'")
                  }
                  errorStyle={{
                    color: '#ed4559',
                    fontFamily: 'Open Sans',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    fontStyle: 'italic',
                    marginTop: '7px',
                  }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <CheckInput
                  name={compName + 'DeliveryZone'}
                  text={'Delivery Zones'}
                  floatingLabelText={'Delivery Zone'}
                  hintText={'Delivery Zone'}
                />
              </div>
              <br />
            </div>
            {this.props.deliveryZone && (
              <DeliveryZone branchId={this.props.branchId} />
            )}
            <CardSimple title="StoreToDoor Settings">
              <div className="row">
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                  <CheckInput
                    name={compName + 'enableStoreToDoor'}
                    text={'enableStoreToDoor'}
                    floatingLabelText={'enableStoreToDoor'}
                    hintText={'enableStoreToDoor'}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                  <TextInput
                    name={compName + 'storeToDoorCompanyId'}
                    label={'storeToDoorCompanyId'}
                    floatingLabelText={'storeToDoorCompanyId'}
                    hintText={'storeToDoorCompanyId'}
                    type={'number'}
                    fullWidth={true}
                    maxLength={5}
                  />
                </div>
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                  <TextInput
                    name={compName + 'storeToDoorLocationId'}
                    label={'storeToDoorLocationId'}
                    floatingLabelText={'storeToDoorLocationId'}
                    hintText={'storeToDoorLocationId'}
                    type={'number'}
                    fullWidth={true}
                    maxLength={5}
                  />
                </div>
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                  <Button
                    name="checkStoretodoorConnection"
                    className="pull-left purpleText"
                    label="Check Connection"
                    secondary={true}
                    onTouchTap={() => this.getStoreToDoorLocationInformation()}
                  />
                  <h6
                    style={{
                      textAlign: 'center',
                      margin: '10px 0 10px 0',
                      fontSize: '12px',
                      fontWeight: '600',
                      color: 'Green',
                    }}
                  >
                    {this.props.storetodoorLocationInfo &&
                      ' Location Name: ' +
                        this.props.storetodoorLocationInfo.name +
                        ' -- Email:' +
                        this.props.storetodoorLocationInfo.email}
                  </h6>
                  <h6
                    style={{
                      textAlign: 'center',
                      margin: '10px 0 10px 0',
                      fontSize: '12px',
                      fontWeight: '600',
                      color: 'Red',
                    }}
                  >
                    {this.props.storetodoorLocationError}
                  </h6>
                </div>
              </div>
              <div className="row">
                <br />
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                  <CheckInput
                    name={compName + 'enableStoreToDoorLockDateAndTime'}
                    text={'Enable Store Lock Date And Time'}
                    floatingLabelText={'Enable Store Lock Date And Time'}
                    hintText={'Enable Store Lock Date And Time'}
                  />
                </div>
              </div>
              {/* Hyperlink to toggle StoretoDoorDeliveryWindow */}
              <div className="row">
                <div className="col-xs-12">
                  <a
                    href="#"
                    style={{ textDecoration: 'underline', color: 'blue' }}
                    onClick={(e) => {
                      e.preventDefault(); // Prevent default link behavior
                      this.toggleWindowVisibility();
                    }}
                  >
                    Display Store to Door Delivery Window Settings Table
                  </a>
                </div>
              </div>

              <div className="row">
                {isWindowVisible && (
                  <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                    <StoretoDoorDeliveryWindow />
                  </div>
                )}
              </div>
            </CardSimple>
          </AccordionDetails>
        </Accordion>
        <CardSimple title="Store Rule Settings" className="mt-2">
          <div className="row">
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <TextInput
                name={compName + 'colorStoreRulesText'}
                label={'colorStoreRulesText'}
                floatingLabelText={'colorStoreRulesText'}
                hintText={'colorStoreRulesText'}
                fullWidth={true}
                maxLength={50}
              />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <TextInput
                name={compName + 'fontSizeStoreRulesContent'}
                label={'fontSizeStoreRulesContent'}
                floatingLabelText={'fontSizeStoreRulesContent'}
                hintText={'fontSizeStoreRulesContent'}
                fullWidth={true}
                type={'number'}
                maxLength={50}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <TextInput
                name={compName + 'fontSizeStoreRulesHeader'}
                label={'fontSizeStoreRulesHeader'}
                floatingLabelText={'fontSizeStoreRulesHeader'}
                hintText={'fontSizeStoreRulesHeader'}
                fullWidth={true}
                type={'number'}
                maxLength={50}
              />
            </div>
          </div>
        </CardSimple>
        <CardSimple title="Payment Settings" className="mt-2">
          <div className="row">
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <CheckInput
                name={compName + 'onlinePaymentEnabled'}
                text={'onlinePaymentEnabled'}
                floatingLabelText={'onlinePaymentEnabled'}
                hintText={'onlinePaymentEnabled'}
              />
            </div>
            <br />
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <CheckInput
                name={compName + 'storePaymentEnabled'}
                text={'storePaymentEnabled'}
                floatingLabelText={'storePaymentEnabled'}
                hintText={'storePaymentEnabled'}
              />
              <br />
            </div>
          </div>
        </CardSimple>
        <CardSimple title="Pick Up Settings" className="mt-2">
          <div className="row">
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <TextInput
                name={compName + 'pickUpOrderReadyEmailText'}
                label={'pickUpOrderReadyEmailText'}
                floatingLabelText={'pickUpOrderReadyEmailText'}
                hintText={'pickUpOrderReadyEmailText'}
                fullWidth={true}
                maxLength={50}
              />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <CheckInput
                name={compName + 'curbSidePickUpEnabled'}
                text={'curbSidePickUpEnabled'}
                floatingLabelText={'curbSidePickUpEnabled'}
                hintText={'curbSidePickUpEnabled'}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <CheckInput
                name={compName + 'driveThroughPickUpEnabled'}
                text={'driveThroughPickUpEnabled'}
                floatingLabelText={'driveThroughPickUpEnabled'}
                hintText={'driveThroughPickUpEnabled'}
              />
              <br />
            </div>
          </div>
        </CardSimple>
        <CardSimple title="Shipment Settings" className="mt-2">
          <div className="row">
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <TextInput
                name={compName + 'shipToHomeCost'}
                label={'shipToHomeCost'}
                floatingLabelText={'shipToHomeCost'}
                hintText={'shipToHomeCost'}
                type={'number'}
                fullWidth={true}
                maxLength={50}
              />
            </div>
            <br />
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <CheckInput
                name={compName + 'shipToHomeEnabled'}
                text={'shipToHomeEnabled'}
                floatingLabelText={'shipToHomeEnabled'}
                hintText={'shipToHomeEnabled'}
              />
              <br />
            </div>

            <div className="row">
              <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 deliverytootip mb-3">
                <span style={{ color: `grey` }}>
                  Max Delivery by Radius (km){' '}
                  <icon
                    className="link_default green-text glyphicon glyphicon-question-sign font-18px "
                    title="Use this setting to limit delivery distance, by setting a maximum delivery radius from your store"
                  />
                </span>
                <br />
                <TextInput
                  name={compName + 'deliveryRadius'}
                  type={'number'}
                  fullWidth={true}
                  maxLength={50}
                  className="tooltiptextfield"
                />
              </div>
              <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 deliverytootip mb-3">
                <span style={{ color: `grey` }}>
                  Base Delivery Cost ($){' '}
                  <icon
                    className="link_default green-text glyphicon glyphicon-question-sign font-18px"
                    title="This is for the base charge setting for delivery cost (can be $0) extra distance fees get added to the base charge"
                  />
                </span>
                <br />
                <TextInput
                  name={compName + 'shippingCost'}
                  type={'number'}
                  fullWidth={true}
                  maxLength={50}
                  className="tooltiptextfield"
                />
              </div>
            </div>
          </div>
        </CardSimple>

        {this.props.province == 'AB' || this.props.province == 'Alberta' ? (
          <CardSimple title="Age Verification Settings" className="mt-2">
            <div className="row">
              <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <CheckInput
                  name={compName + 'ageCheckerEnabled'}
                  text={'ageCheckerEnabled'}
                  floatingLabelText={'ageCheckerEnabled'}
                  hintText={'ageCheckerEnabled'}
                />
              </div>
            </div>
          </CardSimple>
        ) : (
          <div></div>
        )}
        <div className="row marginRightMobile mt-3">
          <div className="col-lg-12">
            <Button
              name="buttonSave"
              className="pull-right btnNewBrandPOS"
              label={LOOKUP.campaign.controls.saveButon}
              primary={true}
              onTouchTap={() =>
                this.saveWebUISettings(isTimeError || isTimeSetError)
              }
            />
            <Button
              type="CancelButton"
              name="buttonCancel"
              className="pull-right btn-space btnCancelOperation"
              label={LOOKUP.common.cancel.text}
              onTouchTap={() => this.redirectToDashboard()}
            />
          </div>
        </div>
      </Grid>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    branchId: state.common.branchId,
    province: state.common.store.provinceState,
    webUISettingModel: selectWebUISettings(state, compName),
    advancedDelivery: state.form.WebUISettingAdvancedDelivery,
    enableStoreToDoorLockDateAndTime:
      state.form.WebUISettingenableStoreToDoorLockDateAndTime,
    deliveryZone: state.form.WebUISettingDeliveryZone,
    deliveryStartTime: state.form[`${compName}deliveryStartHour`],
    deliveryEndTime: state.form[`${compName}deliveryEndHour`],
    storetodoorLocationInfo: state.entity.storetodoorLocationInfo,
    storetodoorLocationError: state.entity.storetodoorLocationError,
    createStoreLockDateNTimeSuccess:
      state.entity.createStoreLockDateNTimeSuccess,
    deleteStoreLockDateNTimeSuccess:
      state.entity.deleteStoreLockDateNTimeSuccess,
    updateStoreLockDateNTimeSuccess:
      state.entity.updateStoreLockDateNTimeSuccess,
  };
};

function mapDispatchToProps(dispatch, ownProps) {
  return {
    getWebUISettings: (branchId, compName) =>
      dispatch(getWebUISettings(branchId, compName)),
    updateWebUISettings: (model) => dispatch(updateWebUISettings(model)),
    getDeliveryZone: (model) => dispatch(getDeliveryZone(model)),
    formInput: (value, name) => dispatch(formInput(value, name)),
    getStoreLockDateNTime: (branchId) =>
      dispatch(getStoreLockDateNTime(branchId)),
    getStoreToDoorLocationInformation: (branchId) =>
      dispatch(getStoreToDoorLocationInformation(branchId)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WithRouter(UISettingPage));
